import { useForexTickers } from '@/integrations/findex/hooks/forex/useForexTickers'
import type { UseAssetFormLayout } from '../types'
import { useUserSettings } from '@/modules/settings/hooks/useUserSettings'
import { ref } from 'vue'
import { tween } from '@/utils/animation/tween'
import { getPrettyAssetUnit } from '@/utils/asset'
import { prettyNumber } from '@/utils/number/format'
import { Display } from '../components/display'

export const averagePurchasePriceLayout = (): UseAssetFormLayout => ({
  needs: ['invested.type', 'asset.type'],
  component: (state) => {
    const forex = useForexTickers()
    const settings = useUserSettings()
    const ticker = forex.getTickerRef(
      state?.invested.type || settings.currency.value,
      settings.currency.value
    )

    const val = ref<number>(0)
    const w = tween(val, { duration: 0.5 })

    return (props) => {
      const state = props.state.value
      const unitName = getPrettyAssetUnit(state?.asset.type, false)
      const totCost = (state?.invested.value || 0) * ticker.value.bid //amountInvested.value
      const shares = state?.quantity || 0 //quantity.value
      const initSharePrice = shares > 0 ? totCost / shares : 0
      val.value = initSharePrice;


      const formatted = prettyNumber(w.value, {
        american: true,
        maxDecimals: 6,
      })

      const title = 'Average Purchase Price'
      const value = `${formatted} ${settings.currency.value} / ${unitName || 'Share'}`

      return <Display title={title} value={value} />
    }
  }
})
